// TODO need a better approach to find course Name
const courseName = window.location.pathname.split('/')[1];

// UTILITY FUNCTIONS

// to initialize the isModalVisible property of each AppHeader Modal's Redux Store
// actType is passed by initial state of each AppHeader Modal's Reducer functions
const wasHeaderModalVisible = actType => {
  const netacadHeaderModalData = JSON.parse(
    localStorage.getItem('netacad-AppHeader-Modal')
  );

  if (netacadHeaderModalData)
    return actType === netacadHeaderModalData[courseName] ? true : false;
  else if (netacadHeaderModalData === null) return false;
};

const mergeNewDataIntoLS = newData => {
  const localStorageData = localStorage.getItem('netacad-AppHeader-Modal');

  // parse existing Local Storage data if available, otherwise blank object
  let existingLSData = localStorageData ? JSON.parse(localStorageData) : {};

  // merge the new data with existing ones we have already in Local Storage
  existingLSData = { ...existingLSData, ...newData };

  // sending off existing Local Storage data with the updated values to local storage
  localStorage.setItem(
    'netacad-AppHeader-Modal',
    JSON.stringify(existingLSData)
  );
};

// REDUX ACTIONS

// function to show modal by dispatching action type provided by AppHeader components
const actionsToShowModal = actionType => {
  return dispatch => {
    // set up the new data to be added in the Localstorage according to current coursename
    let newDataObj = {
      [courseName]: actionType
    };

    // merge the new data object into the Local Storage
    mergeNewDataIntoLS(newDataObj);

    // check if the header link were clicked with the combination of control/command keypress
    let ctrlPlusClickEvent = window.event.ctrlKey || window.event.metaKey;

    if (ctrlPlusClickEvent) {
      window.open(window.location.pathname, '_blank');
    } else {
      dispatch({
        type: actionType // dispatch action type to redux
      });
    }
  };
};

// function to close modal by dispatching action type provided by AppHeader components
const actionsToHideModal = actionType => {
  return dispatch => {
    // set up the new data to be added in the Localstorage according to current coursename
    let newDataObj = {
      [courseName]: ''
    };

    // merge the new data object into the Local Storage
    mergeNewDataIntoLS(newDataObj);

    // dispatch action type to redux
    dispatch({
      type: actionType
    });
  };
};

export { actionsToHideModal, actionsToShowModal, wasHeaderModalVisible };
